__webpack_require__.p = "https://aladinn-edu.web.app/";